import { ADT } from "pb.adt";

export type PagePaymentMethod = {
	/**
	 * In cents.
	 */
	total: number;
	/**
	 * In cents.
	 */
	surcharge?: number;
	/**
	 * e.g. "AUD"
	 */
	currency: string;
	onBack: () => void;
};

export const Page = ADT.define(
	{} as {
		Initialising: {
			onClose: () => void;
		};
		ErrorSetupRequired: {
			onClose: () => void;
		};
		ErrorNetworkFailure: {
			onClose: () => void;
			onRetry: () => void;
		};
		ErrorOperationFailure: {
			onClose: () => void;
			onRetry: () => void;
		};
		PaymentMethodSelection: {
			onClose: () => void;
			onLinkEmail: () => void;
			onLinkSMS: () => void;
		};
		PaymentMethodLinkEmail: PagePaymentMethod & {
			onClose: () => void;
			onSubmit: (email: string) => void | Promise<void>;
		};
		PaymentMethodLinkSMS: PagePaymentMethod & {
			onClose: () => void;
			onSubmit: (phone: string) => void | Promise<void>;
		};
		PaymentFlow: {
			state: ADT<{
				Idle: {
					onCancel: () => void;
					/**
					 * Seconds.
					 */
					timeoutDuration: number;
				};
				/**
				 * Not cancellable, so no `onCancel`: the payment is already being
				 * processed.
				 */
				Processing: {
					/**
					 * Seconds.
					 */
					timeoutDuration: number;
				};
				Approved: { amount: number; onDone: () => void };
			}>;
			transactions: ReadonlyArray<{
				status: "approved" | "declined";
			}>;
			/**
			 * In cents.
			 */
			total: number;
			/**
			 * In cents.
			 */
			surcharge?: number;
			/**
			 * e.g. "AUD"
			 */
			currency: string;
			/**
			 * The email/phone the link was sent to.
			 */
			handle: string;
			createdTimestamp?: string; // ISO-8601
			ecommerceReference: string;
			cancelling?: boolean;
			viewedTimestamp?: string;
		};
		PaymentExpired: {
			onClose: () => void;
		};
		PaymentCancelled: {
			onClose: () => void;
		};
	},
);

export type Page = ADT.define<typeof Page>;
